import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../../lib/pixel';
export function FinalCTA() {
  return <section id="comenzar-protocolo" className="py-24 bg-[#1B3A6B] relative overflow-hidden text-center" data-id="element-2">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-3" />
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#1B3A6B] to-[#0F172A] opacity-90" data-id="element-4" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-6">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6 uppercase tracking-tight" data-id="element-7">
            El momento de forjar el{' '}
            <span className="text-[#F97316]" data-id="element-8">Enfoque de Acero</span> es ahora.
          </h2>

          <p className="text-xl text-blue-100 mb-10 leading-relaxed" data-id="element-9">
            Cada día que pasa sin entrenamiento es un día más que el algoritmo
            gana terreno. Tu hijo tiene el potencial — dale el sistema que
            Silicon Valley no quiere que tenga.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-10">
            <Button size="xl" className="w-full sm:w-auto px-12 py-6 text-xl shadow-2xl border-2 border-white/10" onClick={() => {
            trackAddToCart();
            window.location.href = 'https://enfoquedeacero.com/cart/44821051113574:1';
          }} data-id="element-11">
              COMENZAR EL PROTOCOLO HOY
              <ArrowRight className="ml-2 h-6 w-6" data-id="element-12" />
            </Button>
          </div>

          <p className="mt-6 text-sm text-blue-300 opacity-70" data-id="element-13">
            ✓ Acceso inmediato &nbsp;·&nbsp; ✓ Para siempre tuyo
          </p>
        </motion.div>
      </div>
    </section>;
}